function FAQSection() {
  return null;
}

export default FAQSection;
